import { useState } from "react";
import { useSelector } from "react-redux";
import TableRowMob from './table-row-mob'
import TableRowMobBooking from './table-booking-row-mob'

const TableBodyMob = ({columns, data, eventTypeId, bookingPage, reality, realty}) => {

    if(!data.length) return <div className="no-results">Нет данных, соответствующих выбранным фильтрам</div> 

    return (
        <div className="table__body">    
            {!bookingPage && data.map((item, index) => <TableRowMob data={item} columns={columns} key={index} eventTypeId={eventTypeId} realty={realty} />)}   
            {bookingPage && data.map((item, i) => <TableRowMobBooking reality={reality} data={item} columns={columns} key={i} />)}     
        </div>
    )
}

export default TableBodyMob